import { Component, ChangeDetectionStrategy, Input, OnInit } from '@angular/core';

import { MessageService } from '@app/services/message.service';

import { IMessageData } from './message.model';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageComponent implements OnInit {
  @Input() message: IMessageData;
  isHover: boolean;
  isTimePassed = false;
  isMouseOver: boolean;

  constructor(private _messageService: MessageService) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.isTimePassed = true;
      if (!this.isMouseOver) {
        this.close();
      }
    }, 7000);
  }

  close(): void {
    this._messageService.removeMessageFromList(this.message);
  }

  onMouseEnter(): void {
    this.isMouseOver = true;
  }

  onMouseLeave(): void {
    if (this.isTimePassed) {
      this.close();
    }
  }
}
